/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/handshake'
export default icon
